<template>
  <v-sheet color="grey lighten-4" class="py-10">
    <Loading v-if="loading" />

    <v-container v-else>
      <Title>Estrutura</Title>

      <v-tabs
        background-color="transparent"
        v-model="tab"
        center-active
        show-arrows
        centered
        class="mt-8"
      >
        <v-tab v-for="({ title }, keyItems) in items" :key="keyItems">
          <div>{{ title }}</div>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab" class="pa-4 pa-md-5">
        <v-tab-item
          v-for="({ img, text }, tabItemsKeys) in items"
          :key="tabItemsKeys"
          class="item"
        >
          <v-row>
            <v-col cols="12" sm="4" v-if="img">
              <img :src="files + img" class="d-block item-img" />
            </v-col>
            <v-col cols="12" :sm="!img ? 12 : 8">
              <div
                class="text-body-2 font-weight-regular"
                v-if="text"
                v-html="text"
              ></div>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-sheet>
</template>

<script>
import Loading from "../../widgets/Loading.vue";
import Title from "../../widgets/Title.vue";

const _config = {
  mod: "structure",
};

export default {
  data: () => ({
    loading: true,
    tab: null,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    Title,
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    width: 100%;
  }
}
</style>
